import React from "react";
import "./Apply_round_btn.css";
import { Button } from "react-bootstrap";

function Apply_round_btn({ btnText, onClick }) {
  return (
    <>
      <section className="Apply_round_btn_holder">
        <Button className="Apply_round_btn" onClick={onClick}>
          {btnText}
        </Button>
      </section>
    </>
  );
}

export default Apply_round_btn;
